import React from 'react';
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { FormWrapper } from './Wrappers';
import { genericMemo } from './Types';

function ExpenseTypeSelectRaw({onChange, ...props}: {onChange: (newValue: number) => void, id?: string}) {
  return (
    <Select {...props} onChange={(e) => {onChange(e.target.value as number)}}>
      <MenuItem value={0}>Faktura</MenuItem>
      <MenuItem value={1}>Kvitto på utlägg</MenuItem>
      <MenuItem value={2}>Kvitto på inköp med klubbens betalkort</MenuItem>
    </Select>
  )
}

const ExpenseTypeSelect = genericMemo(FormWrapper({Component: ExpenseTypeSelectRaw}))

export default ExpenseTypeSelect
